export default function GlobalToast({ toast }) {
  if (!toast?.open) return null;
  let color = "#333";
  if (toast.type === "success") color = "#28a745";
  if (toast.type === "error") color = "#dc3545";
  if (toast.type === "info") color = "#007bff";
  return (
    <div
      style={{
        position: "fixed",
        top: 24,
        left: "50%",
        transform: "translateX(-50%)",
        background: color,
        color: "#fff",
        padding: "12px 32px",
        borderRadius: 8,
        zIndex: 9999,
        fontWeight: 600,
        fontSize: 18,
        boxShadow: "0 2px 12px #0002",
      }}
    >
      {toast.message}
    </div>
  );
}
